import { useQuery } from '@tanstack/react-query';

import { getTranslationsForLocale } from './translationApi';

export const useFetchTranslationsForLocale = (locale: string) => {
  return useQuery({
    queryKey: ['translations', 'get', locale],
    queryFn: () => getTranslationsForLocale(locale),
    enabled: !!locale
  });
};
